import { httpClient } from "../http/httpClient";
import { PartnerType } from "@/app/utils/partners.enum";

export type OffersParams = {
  cpf: string;
};

export type OffersResponse = {
  id: string;
  offers: {
    amount: string;
    installments: string;
    installmentValue: string;
    taxValue: string;
    ensuranceValue: string;
    installmentsList: number[];
  } | null;
  message?: string;
};

export const getOffers = async (payload: OffersParams) => {
  const { data } = await httpClient
    .get<OffersResponse>(`/c6/offers/${payload.cpf}`, {
      journey: PartnerType.C6,
    })
    .catch((error) => {
      throw error?.response?.data || error;
    });

  return data;
};
